import { render, staticRenderFns } from "./RemarkPayments.vue?vue&type=template&id=1122b32f&scoped=true"
import script from "./RemarkPayments.vue?vue&type=script&lang=js"
export * from "./RemarkPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122b32f",
  null
  
)

export default component.exports